import React, { useState, useEffect } from 'react';
import Table from '../../../../../../components/Table/Table';
import Filters from '../../../../../../components/Filters/Filters';
import './ServiceOffered.css';
import { useNavigate } from 'react-router-dom';
// Icons
import toggleActive from '../../../../../../assets/toggleActive.png';
import toggleInactive from '../../../../../../assets/toggleInactive.png';
import trashActive from '../../../../../../assets/tokens/trashActive.png';
import trashInactive from '../../../../../../assets/tokens/trashInactive.png';
import eyeOn from '../../../../../../assets/tokens/eyeOn.png';
//services
import { groupService } from '../../../../../../services/Group';
//utils
import { formatDate } from '../../../../../../utils/utils';

const ServiceOffered = ({ groupId, services }) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [servicesData, setServicesData] = useState([]);
  const [columnsShare, setColumnsShare] = useState(1);
  const [columns, setColumns] = useState([]);

  const categories = [
    'Technology',
    'Healthcare',
    'Education',
    'Professional Services',
    'Home Services',
    'Creative & Design',
    'Business Services',
    'Personal Care',
    'Other'
  ];

  // Mock data for demonstration
  useEffect(() => {
    fetchColumns();
    console.log('services', services);
    fetchServices(1);
  }, [filters]);

  const fetchServices = async (page = 1) => {
    try {
      const params = {
        page: page,
        items_per_page: 10,
        ...filters
      };
      
      const response = await groupService.serviceOfferedGroup(groupId, params);
      console.log('Services fetched:', response);
      
      if(response && response.data && response.data.length > 0) {
        // Set total items from the response for pagination
        setTotalItems(response.data.total || response.data.length);
        
        // Map the data with formatted dates
        let data = (response.data.data || response.data).map(service => ({
          ...service,
          created_at: formatDate(service.created_at),
          status: service.is_active ? 'active' : 'inactive'
        }));
        
        setServicesData(data);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const fetchColumns = () => {
    let columns = [{
      header: 'Supplier',
      field: 'provider'
    }, {
      header: 'Category',
      field: 'category'
    }, {
      header: 'Subcategory',
      field: 'subcategory'
    }, {
      header: 'Modality',
      field: 'service_type'
    }, {
      header: 'Supplier since',
      field: 'created_at'
    }, {
      header: 'Amount of barter bucks',
      field: 'service_cost'
    }, {
      header: 'Status',
      field: 'status'
    }];

    columns.push({
      header: '',
      render: (row) => (
        <button className="action-btn" onClick={() => handleView(row)}>
          <img src={eyeOn} alt="view" />
        </button>
      )
    });

    columns.push({
      header: '',
      render: (row) => (
        <button className="action-btn" onClick={() => handleToggle(row)}>
          <img src={row.status === 'active' ? toggleActive : toggleInactive} alt="Toggle" />
        </button>
      )
    });

    columns.push({
      header: '',
      render: (row) => (
        <button className="action-btn" onClick={() => handleDelete(row)}>
          <img src={row.status === 'active' ? trashActive : trashInactive} alt="trash" />
        </button>
      )
    });

    setColumnsShare(3);
    setColumns(columns);
  };

  const handleView = (row) => {
    console.log('row', row);
    navigate(`/groups/group-details/service/${row.service_id}`, {
      state: { serviceData: row }
    });
  };

  const handleDelete = (row) => {
    // Delete logic here
    console.log(`Delete service ${row.id}`);
  };

  const handleToggle = (row) => {
    const newStatus = row.status === 'Active' ? 'Inactive' : 'Active';
    // Update status logic here
    console.log(`Toggle status for service ${row.id} to ${newStatus}`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchServices(page);
  };

  return (
    <div className="services-container">
      <div className="filters-section">
        <Filters
          onApplyFilters={setFilters}
          filters={[
            { 
              id: 'status',
              label: 'Status', 
              type: 'checkbox', 
              options: ['Active', 'Inactive'] 
            },
            { 
              id: 'modality', 
              label: 'Modality', 
              type: 'checkbox', 
              options: ['Physical', 'Virtual', 'Both'] 
            },
            {
              id: 'category',
              label: 'Category',
              type: 'dropdown',
              options: categories.map((category) => ({
                label: category,
                value: category
              }))
            },
            { 
              id: 'supplierSince', 
              label: 'Supplier since', 
              type: 'date',
              placeholder: 'dd/mm/yyyy - dd/mm/yyyy'
            }
          ]}
        />
      </div>
      <div className="table-section">
        <Table
          columns={columns}
          data={servicesData}
          columnsShare={columnsShare}
          currentPage={currentPage}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ServiceOffered;
